<template>
<BaseModal :id="'deletion-validations'" :title="`Validations`" :size="'lg'" :message="message" @close="close($event)">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
        <div style="margin-top: 15px" class="w-100 table-responsive defaultproject__table overflow-y--2 table-fix-head" :style="`max-height: 35rem`">
            <table class="table animate__animated animate__fadeIn animate__fast">
                <thead style="background-color: #f1f1f1">
                    <tr>
                        <th style="font-weight: normal !important" class="header-item-manual" v-for="(item, i) in validation_table_headers" :key="i" scope="col" v-html="item.text" />
                    </tr>
                </thead>
                <tbody class="">
                    <template>
                        <tr v-for="(item, i) in validate_data" :key="i">
                            <td v-for="(header, i) in validation_table_headers" :key="i" v-html="item[header.value]"/>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </template>
</BaseModal>
</template>

  
  
<script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import BaseModal from "@/components/BaseModal";

export default {
    name: "DeletionValidationModal",

    props: ["breadcrumb", "validate_data", "validation_table_headers", "message"],

    components: {
        BaseModal,
        Breadcrumb,
    },

    data() {
        return {
            select_all: true,
        };
    },

    methods: {
        close(event) {
            this.$emit("close", event);
        },
    },

    computed: {},

    mounted() {},
};
</script>
